var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4031 5.42844V30.5597C24.4031 32.9906 22.432 34.9618 20.001 34.9618C17.5701 34.9618 15.5989 32.9906 15.5989 30.5597V16.8744C15.5989 15.3296 14.6601 13.938 13.2255 13.3632C9.60893 11.9094 5.99242 10.4556 2.37829 9.00185C0.941266 8.42225 0 7.03312 0 5.48592V5.40688C0 2.97352 1.97352 1 4.40689 1H19.9723C22.42 1 24.4031 2.9831 24.4031 5.42844Z",
    fill: "#896BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9994 9.48069C39.9706 12.0506 37.7888 14.0816 35.2189 14.0816H32.443C30.3641 14.0816 28.6804 15.7653 28.6804 17.8442V36.1327C28.6804 38.2643 26.9536 39.9912 24.822 39.9912H23.7346C21.603 39.9912 19.8762 38.2643 19.8762 36.1327V9.43757C19.8762 6.86289 21.9647 4.77441 24.5394 4.77441H35.3458C36.632 4.77441 37.7959 5.29414 38.6366 6.1372C39.4916 6.98744 40.0138 8.17539 39.9994 9.48069Z",
    fill: "#6F2DBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.403 5.42835V30.5596C24.403 32.9905 22.4319 34.9617 20.001 34.9617C19.9578 34.9617 19.9171 34.9617 19.874 34.9593V9.43766C19.874 6.92525 21.8643 4.8751 24.3551 4.7793C24.3887 4.99006 24.403 5.20561 24.403 5.42835Z",
    fill: "#7C21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.e0840ecd1a10d931e546b4533d72be79.svg";
export { ForwardRef as ReactComponent };